import React from 'react';
import { Package } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
export function ValueTable() {
  return <section className="py-10 bg-slate-800/30 border-y border-slate-800" data-id="element-575">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-576">
        <ScrollFadeIn data-id="element-577">
          <div className="text-center mb-12" data-id="element-578">
            <Package className="w-10 h-10 text-amber-500 mx-auto mb-4" data-id="element-579" />
            <h2 className="text-3xl md:text-4xl font-serif text-slate-50" data-id="element-580">
              Everything You're Getting Today
            </h2>
          </div>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.1} data-id="element-581">
          <div className="bg-slate-800 border border-slate-700 rounded-2xl overflow-hidden shadow-2xl" data-id="element-582">
            {/* Row 1 */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-700" data-id="element-583">
              <span className="text-slate-50 font-medium" data-id="element-584">
                The Cortisol Switch (Main eBook)
              </span>
              <span className="text-slate-400 font-medium shrink-0 ml-4" data-id="element-585">
                $37
              </span>
            </div>

            {/* Row 2 */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-700 bg-slate-800/50" data-id="element-586">
              <span className="text-slate-50 font-medium" data-id="element-587">
                Bonus #1: The 3AM Rescue Kit
              </span>
              <span className="text-slate-400 font-medium shrink-0 ml-4" data-id="element-588">
                $37
              </span>
            </div>

            {/* Row 3 */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-700" data-id="element-589">
              <span className="text-slate-50 font-medium" data-id="element-590">
                Bonus #2: Cortisol-Safe Grocery Map
              </span>
              <span className="text-slate-400 font-medium shrink-0 ml-4" data-id="element-591">
                $37
              </span>
            </div>

            {/* Row 4 */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-700 bg-slate-800/50" data-id="element-592">
              <span className="text-slate-50 font-medium" data-id="element-593">
                Bonus #3: The Coffee Exit Plan
              </span>
              <span className="text-slate-400 font-medium shrink-0 ml-4" data-id="element-594">
                $37
              </span>
            </div>

            {/* Total Value */}
            <div className="flex items-center justify-between px-6 py-5 border-b-2 border-amber-500/30 bg-amber-500/5" data-id="element-595">
              <span className="text-amber-400 font-bold uppercase tracking-wide text-sm" data-id="element-596">
                Total Value
              </span>
              <span className="text-amber-400 font-bold text-xl shrink-0 ml-4" data-id="element-597">
                $148
              </span>
            </div>

            {/* Your Price */}
            <div className="flex items-center justify-between px-6 py-8 bg-slate-900" data-id="element-598">
              <span className="text-slate-50 font-bold text-lg" data-id="element-599">
                Your Price Today
              </span>
              <span className="text-emerald-400 font-bold text-4xl shrink-0 ml-4" data-id="element-600">
                $6.39
              </span>
            </div>
          </div>
        </ScrollFadeIn>
      </div>
    </section>;
}